<ion-app>
  @if (isAuthenticated()) {
    <ion-menu
      side="end"
      type="overlay"
      contentId="app-content"
      menuId="main-menu"
      class="orbit-menu"
    >
      <ion-content [scrollY]="false">
        <ion-list>
          <ion-item mode="ios" lines="none" class="sidebar-user-details menu-item">
            <ion-label>
              {{ memberDisplayName() }}<br />
              <small>Card #{{ memberCardNumber() }}</small>
            </ion-label>
            <ion-icon
              slot="start"
              class="profile-avatar"
              src="assets/fontawesome/regular/user-vneck.svg"
              aria-label="Profile"
            ></ion-icon>
          </ion-item>

          <ion-menu-toggle auto-hide="true">
            <ion-item mode="ios" lines="none" class="menu-item" button (click)="navigateTo('/profile-update')">
              <ion-label>My Profile</ion-label>
              <ion-icon slot="start" src="assets/fontawesome/regular/user-vneck.svg"></ion-icon>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle auto-hide="true">
            <ion-item mode="ios" lines="none" class="menu-item" button (click)="callSupport()">
              <ion-label>Contact Call Center</ion-label>
              <ion-icon slot="start" src="assets/fontawesome/regular/headset.svg"></ion-icon>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle auto-hide="true">
            <ion-item mode="ios" lines="none" class="menu-item" button (click)="navigateTo('/terms-conditions')">
              <ion-label>Terms &amp; Conditions</ion-label>
              <ion-icon slot="start" src="assets/fontawesome/regular/square-list.svg"></ion-icon>
            </ion-item>
          </ion-menu-toggle>

          @if (showBiometricToggle()) {
            <ion-item mode="ios" lines="none" class="menu-item">
              <ion-label>Biometric Sign-In</ion-label>
              <ion-icon slot="start" src="assets/fontawesome/duotone/fingerprint.svg"></ion-icon>
              <ion-toggle
                slot="end"
                [checked]="biometricLoginEnabled()"
                (ionChange)="onBiometricToggleChanged($event)"
              ></ion-toggle>
            </ion-item>
          }

          <ion-menu-toggle auto-hide="true">
            <ion-item mode="ios" lines="none" class="menu-item logout-item" button (click)="logout()">
              <ion-label>Log Out</ion-label>
              <ion-icon slot="start" src="assets/fontawesome/regular/right-from-bracket.svg"></ion-icon>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>

      <ion-footer class="menu-version">
        <span>Version {{ version }}</span>
      </ion-footer>
    </ion-menu>
  }

  <ion-router-outlet id="app-content"></ion-router-outlet>
</ion-app>
